import {useContext} from "react";

import TeamCard from "../../components/teamCard/TeamCard";
import StyleContext from "../../contexts/StyleContext";
import {teamSection} from "../../portfolio";

import "../team/Team.scss";

export default function Team() {
  const {isDark} = useContext(StyleContext);

  if (!teamSection || !teamSection.display) {
    return null;
  }

  // Defensive checks for arrays
  const faculty = Array.isArray(teamSection.faculty) ? teamSection.faculty : [];
  const students = Array.isArray(teamSection.students)
    ? [...teamSection.students].sort((a, b) => a.title.localeCompare(b.title))
    : [];

  // Only show alumni section if there's alumni data
  const hasAlumni =
    teamSection.alumni &&
    ((Array.isArray(teamSection.alumni.formerPhd) &&
      teamSection.alumni.formerPhd.length > 0) ||
      (Array.isArray(teamSection.alumni.postdocs) &&
        teamSection.alumni.postdocs.length > 0) ||
      (Array.isArray(teamSection.alumni.formerMasters) &&
        teamSection.alumni.formerMasters.length > 0) ||
      (Array.isArray(teamSection.alumni.visiting) &&
        teamSection.alumni.visiting.length > 0));

  return (
    <div className="main" id="team">
      <div className="team-main-div">
        <div className="team-header">
          <h1
            className={
              isDark ? "dark-mode heading team-heading" : "heading team-heading"
            }
          >
            {teamSection.title || "Team"}
          </h1>
          <p
            className={
              isDark
                ? "dark-mode subTitle team-subtitle"
                : "subTitle team-subtitle"
            }
          >
            {teamSection.subtitle || ""}
          </p>
        </div>

        {faculty.length > 0 && (
          <div className="team-category">
            <h2
              className={
                isDark
                  ? "dark-mode heading team-subheading"
                  : "heading team-subheading"
              }
            >
              Faculty
            </h2>
            <div className="team-cards-div">
              {faculty.map((card, i) => (
                <TeamCard
                  key={i}
                  isDark={isDark}
                  cardInfo={{
                    title: card.title,
                    description: card.subtitle,
                    image: card.image,
                    imageAlt: card.imageAlt,
                    advisor: card.advisor,
                    footer: card.footerLink || []
                  }}
                />
              ))}
            </div>
          </div>
        )}

        {students.length > 0 && (
          <div className="team-category">
            <h2
              className={
                isDark
                  ? "dark-mode heading team-subheading"
                  : "heading team-subheading"
              }
            >
              Students
            </h2>
            <div className="team-cards-div">
              {students.map((card, i) => (
                <TeamCard
                  key={i}
                  isDark={isDark}
                  cardInfo={{
                    title: card.title,
                    description: card.subtitle,
                    image: card.image,
                    imageAlt: card.imageAlt,
                    advisor: card.advisor,
                    footer: card.footerLink || []
                  }}
                />
              ))}
            </div>
          </div>
        )}

        {/* Alumni Section with Subsections */}
        {hasAlumni && (
          <div className="team-category">
            <h2
              className={
                isDark
                  ? "dark-mode heading team-subheading"
                  : "heading team-subheading"
              }
            >
              Alumni
            </h2>

            {/* Former Ph.D Students */}
            {teamSection.alumni &&
              Array.isArray(teamSection.alumni.formerPhd) &&
              teamSection.alumni.formerPhd.length > 0 && (
                <div className="team-subcategory">
                  <h3
                    className={
                      isDark
                        ? "dark-mode heading team-subsubheading"
                        : "heading team-subsubheading"
                    }
                  >
                    Former Ph.D Students
                  </h3>
                  <div className="team-cards-div">
                    {teamSection.alumni.formerPhd.map((card, i) => (
                      <TeamCard
                        key={i}
                        isDark={isDark}
                        cardInfo={{
                          title: card.title,
                          description: card.subtitle,
                          image: card.image,
                          imageAlt: card.imageAlt,
                          advisor: card.advisor,
                          footer: card.footerLink || []
                        }}
                      />
                    ))}
                  </div>
                </div>
              )}

            {/* Post-doctoral Scholars */}
            {teamSection.alumni &&
              Array.isArray(teamSection.alumni.postdocs) &&
              teamSection.alumni.postdocs.length > 0 && (
                <div className="team-subcategory">
                  <h3
                    className={
                      isDark
                        ? "dark-mode heading team-subsubheading"
                        : "heading team-subsubheading"
                    }
                  >
                    Current and Former Post-doctoral Scholars
                  </h3>
                  <div className="team-cards-div">
                    {teamSection.alumni.postdocs.map((card, i) => (
                      <TeamCard
                        key={i}
                        isDark={isDark}
                        cardInfo={{
                          title: card.title,
                          description: card.subtitle,
                          image: card.image,
                          imageAlt: card.imageAlt,
                          advisor: card.advisor,
                          footer: card.footerLink || []
                        }}
                      />
                    ))}
                  </div>
                </div>
              )}

            {/* Former Master Students */}
            {teamSection.alumni &&
              Array.isArray(teamSection.alumni.formerMasters) &&
              teamSection.alumni.formerMasters.length > 0 && (
                <div className="team-subcategory">
                  <h3
                    className={
                      isDark
                        ? "dark-mode heading team-subsubheading"
                        : "heading team-subsubheading"
                    }
                  >
                    Former Master Students
                  </h3>
                  <div className="team-cards-div">
                    {teamSection.alumni.formerMasters.map((card, i) => (
                      <TeamCard
                        key={i}
                        isDark={isDark}
                        cardInfo={{
                          title: card.title,
                          description: card.subtitle,
                          image: card.image,
                          imageAlt: card.imageAlt,
                          advisor: card.advisor,
                          footer: card.footerLink || []
                        }}
                      />
                    ))}
                  </div>
                </div>
              )}

            {/* Visiting Scholars and Students */}
            {teamSection.alumni &&
              Array.isArray(teamSection.alumni.visiting) &&
              teamSection.alumni.visiting.length > 0 && (
                <div className="team-subcategory">
                  <h3
                    className={
                      isDark
                        ? "dark-mode heading team-subsubheading"
                        : "heading team-subsubheading"
                    }
                  >
                    Visiting Scholars and Students
                  </h3>
                  <div className="team-cards-div">
                    {teamSection.alumni.visiting.map((card, i) => (
                      <TeamCard
                        key={i}
                        isDark={isDark}
                        cardInfo={{
                          title: card.title,
                          description: card.subtitle,
                          image: card.image,
                          imageAlt: card.imageAlt,
                          advisor: card.advisor,
                          footer: card.footerLink || []
                        }}
                      />
                    ))}
                  </div>
                </div>
              )}
          </div>
        )}
      </div>
    </div>
  );
}
